<template>
  <div class="error-page">
    <h1>404</h1>
    <em>Page not found...</em>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>



// WEBPACK FOOTER //
// src/components/404.vue